import React from "react";
import withStyles from "components/with-styles";
import MUICard from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import styles from "./styles/card.css.js";
import DataGrid from "components/data-grid";
import PropTypes from "prop-types";
import cn from "classnames";

const Card = ({ classes, children, className, title }) => {
  return (
    <MUICard className={cn(classes.root, className)}>
      {title && <Typography variant="h6">{title}</Typography>}
      <DataGrid className={classes.content}>{children}</DataGrid>
    </MUICard>
  );
};

Card.propTypes = {
  /**
   * Clase adicional del Componente
   */
  className: PropTypes.string,
  /**
   * Títutlo de la tarjeta
   */
  title: PropTypes.node,
};

export default withStyles(styles)(Card);
